export default __webpack_public_path__ + "static/media/notifications_1.7ce200a5.png";